import { useTheme } from '@insight-health-ai/roseate/theme';
import { Call } from 'src/models';

export const CallUserSentiment = ({ call }: { call: Call }) => {
  const { colors, fontSize } = useTheme();

  const userSentimentMap: Record<string, { label: string; color: string }> = {
    positive: { label: 'Positive', color: colors.success },
    negative: { label: 'Negative', color: colors.danger },
    neutral: { label: 'Neutral', color: colors.info },
  };

  const sentiment = (
    call.call_analytics?.call_analysis?.user_sentiment || ''
  ).toLowerCase();

  const userSentiment = userSentimentMap[sentiment] || {
    label: 'Unknown',
    color: colors.secondary,
  };

  return (
    <div className="flex items-center gap-1">
      <span
        style={{
          color: userSentiment?.color,
          fontSize: fontSize['2xl'][0],
        }}
      >
        •
      </span>
      <span className="text-xs uppercase">{userSentiment?.label}</span>
    </div>
  );
};
